module.exports = __webpack_public_path__ + "img/avatar2_w.f8592dcd.svg";